export default "__VITE_ASSET__60768d12__"